var m = require('mithril');

var tachyons = require('../stylesheets/vendor/tachyons.min.css');
var ionicons = require('ionicons');
var session = require('./auth/models/session');

var routes = {};

Object.assign(routes, require('./auth/routes'));

if (!session.user()) {
  if (!nrActiveProfile) {
    var nrstyles = require('../stylesheets/nr.scss'); // Important
    session.next(m.route.get());
    m.route(document.body, '/login', routes);
  } else {
    session.user(nrActiveProfile);
    var user = nrActiveProfile;
    Object.assign(routes, require('./dashboards/routes'));
    Object.assign(routes, require('./ontology/routes'));
    Object.assign(routes, require('./equipment/routes'));
    Object.assign(routes, require('./system/routes'));
    Object.assign(routes, require('./diagrams/routes'));
    Object.assign(routes, require('./locations/routes'));
    Object.assign(routes, require('./alarms/routes'));
    Object.assign(routes, require('./data/routes'));
    Object.assign(routes, require('./reports/routes'));
    Object.assign(routes, require('./calibrations/routes'));
    if (user.isSuperuser == 1 || user.isSuperuser == true) {
      Object.assign(routes, require('./modbus/routes'));
      Object.assign(routes, require('./lontalk/routes'));
      Object.assign(routes, require('./rest/routes'));
      Object.assign(routes, require('./bacnet/routes'));
      Object.assign(routes, require('./network/routes'));
      Object.assign(routes, require('./binding/routes'));
      Object.assign(routes, require('./events/routes'));
      Object.assign(routes, require('./settings/routes'));
    }
    // Require custom styles here so they are loaded last (top CSS priority) in the webpack build
    var nrstyles = require('../stylesheets/nr.scss');

    m.route(document.body, '/', routes);
    if (!window.location.hash) {
      if (user.homeLocation) m.route.set('/location/' + user.homeLocation)
      else if (user.homeDashboard) m.route.set('/dashboard/' + user.homeDashboard)
    }
  }
}
